module.exports = "<i class=\"icon\">\r\n    <svg width=\"30\" height=\"35\" class=\"rfp-icon\">\r\n        <image\r\n            ng-if=\"$ctrl.enabled\"\r\n            xlink:href=\"assets/img/rfps-globe-grey.svg\"\r\n            src=\"assets/img/rfps-globe-grey.svg\"\r\n            width=\"30\"\r\n            height=\"30\"\r\n        ></image>\r\n        <image\r\n            ng-if=\"!$ctrl.enabled\"\r\n            xlink:href=\"assets/img/rfp-globe.svg\"\r\n            src=\"assets/img/rfp-globe.svg\"\r\n            width=\"30\"\r\n            height=\"30\"\r\n        ></image>\r\n    </svg>\r\n</i>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/rfpIcon/rfpIcon.html
 ** module id = 466
 ** module chunks = 0
 **/